hasSelectionSet_1